import { DateValue, differenceInTime } from '@toggle/helpers';
import * as React from 'react';

interface DateComponentProp {
  date: DateValue;
  className?: string;
}

export function FormattedRelativeDate({
  date,
  className = '',
}: DateComponentProp) {
  const datetime = new Date(date).toISOString();
  return (
    <time
      className={className}
      dateTime={datetime}
      data-testid="formatted-relative-date"
    >
      {differenceInTime(new Date(), date)}
    </time>
  );
}
